// Angular Imports
import { inject } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router'
// Store Imports
import { Store } from '@ngrx/store'
import { selectLogged } from '@store/selectors'
// Thirdparty Imports
import { map, take } from 'rxjs'

export const isLoggedGuard: CanActivateFn = (
	route: ActivatedRouteSnapshot,
	state: RouterStateSnapshot
) => {
	const _router = inject(Router)
	const _store = inject(Store)

	return _store.select(selectLogged).pipe(
		take(1),
		map((logged: boolean) => {
			// Verify if user is logged
			if (logged) {
				return true
			} else {
				_router.navigate(['/login'])
				return false
			}
		})
	)
}
